module.exports = __webpack_public_path__ + "static/Calluna-Light-webfont-ce414fe603cd7d27fc1fda8db8b995d4.woff2";